
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm10.67-2.06l.024.382-.385-.047c-1.4-.179-2.624-.785-3.663-1.802l-.507-.505-.131.373c-.277.83-.1 1.709.477 2.299.308.326.238.373-.293.179-.184-.062-.346-.109-.361-.086-.054.055.13.762.277 1.041.2.389.608.77 1.054.994l.377.18-.446.007c-.431 0-.447.008-.4.17.153.506.761 1.042 1.438 1.275l.477.163-.415.248a4.332 4.332 0 01-2.062.575c-.346.008-.631.039-.631.062 0 .078.939.513 1.485.684 1.639.505 3.586.287 5.047-.575 1.04-.614 2.078-1.833 2.563-3.014.261-.629.523-1.779.523-2.33 0-.358.023-.404.454-.831.254-.249.492-.52.538-.598.077-.148.07-.148-.323-.016-.654.233-.746.202-.423-.148.239-.248.523-.699.523-.83 0-.024-.115.015-.246.085a4.293 4.293 0 01-.677.264l-.416.132-.377-.256c-.207-.14-.5-.296-.654-.342-.392-.109-.992-.093-1.346.03-.962.35-1.57 1.251-1.5 2.238z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    